import React from 'react';
import {
  ToggleRadioField,
  type ToggleRadioOption,
} from '~/components/forms/ToggleRadioField';

type BuyWithAPartnerFieldProps = {
  name: string;
  label?: string;
};

const BuyWithAPartnerField: React.FC<BuyWithAPartnerFieldProps> = ({
  name,
  label,
}) => {
  const options: ToggleRadioOption<boolean>[] = [
    { value: true, label: 'Ja' },
    { value: false, label: 'Nee' },
  ];

  return (
    <ToggleRadioField
      name={name}
      label={label}
      options={options}
      gridClassName="grid grid-cols-2 gap-3 md:flex md:h-10 md:items-center"
      labelClassName="h-[44px] w-full md:w-auto"
    />
  );
};

export default BuyWithAPartnerField;
